module.exports = __webpack_public_path__ + "static/media/clockPicture.f186d6bb.svg";